// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ewkZjjfOe7kwmPc_ {
  width: 120px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: #20336c;
  border-color: #20336c;
  font-weight: 500;
}

.ewkZjjfOe7kwmPc_:active {
  background-color: #19295a;
  border-color: #19295a;
}

.ewkZjjfOe7kwmPc_:focus {
  box-shadow: none;
}

.ewkZjjfOe7kwmPc_:focus-visible {
  box-shadow: 0 0 0 0.2rem #a6d5fa;
}

.nzbL2I8xlPkEjlX9 {
  width: 36px;
  height: 36px;
  padding: 7px;
}

.nzbL2I8xlPkEjlX9 .p-button-icon {
  color: #20336C;
}

.nzbL2I8xlPkEjlX9 .pi-download:before {
  font-size: 1.2rem;
}

.nzbL2I8xlPkEjlX9:hover {
  background-color: transparent;
  border: transparent;
}

.nzbL2I8xlPkEjlX9:focus {
  box-shadow: none;
}

.nzbL2I8xlPkEjlX9:focus-visible {
  box-shadow: 0 0 0 0.2rem #2196f3;
}`, "",{"version":3,"sources":["webpack://./src/components/ImportButton/ImportButton.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".button {\r\n  width: 120px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 8px;\r\n  background-color: #20336c;\r\n  border-color: #20336c;\r\n  font-weight: 500;\r\n}\r\n\r\n.button:active {\r\n  background-color: #19295a;\r\n  border-color: #19295a;\r\n}\r\n\r\n.button:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.button:focus-visible {\r\n  box-shadow: 0 0 0 0.2rem #a6d5fa;\r\n}\r\n\r\n.iconButton {\r\n  width: 36px;\r\n  height: 36px;\r\n  padding: 7px;\r\n}\r\n\r\n.iconButton :global(.p-button-icon) {\r\n  color: #20336C;\r\n}\r\n\r\n.iconButton :global(.pi-download:before) {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.iconButton:hover {\r\n  background-color: transparent;\r\n  border: transparent;\r\n}\r\n\r\n.iconButton:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.iconButton:focus-visible {\r\n  box-shadow: 0 0 0 0.2rem #2196f3;\r\n}"],"sourceRoot":""}]);
// Exports
export var button = `ewkZjjfOe7kwmPc_`;
export var iconButton = `nzbL2I8xlPkEjlX9`;
export default ___CSS_LOADER_EXPORT___;
